// extracted by mini-css-extract-plugin
export default {"Alert":"SpotifyTrackingAlert_Alert__jhz5y","Critical":"SpotifyTrackingAlert_Critical__4lYuD","Dismiss":"SpotifyTrackingAlert_Dismiss__eHSJz"};